export const zendeskMixin = {
  methods: {
    $_zendesk_set_identify(name, email) {
      window.zE('webWidget', 'prefill', {
        name: {
          value: name
          // readOnly: true,
        },
        email: {
          value: email
          // readOnly: true,
        }
      });
      window.zE('webWidget', 'identify', {
        name: name,
        email: email
      });
    },

    $_zendesk_update_settings(settings = {}) {
      window.zE('webWidget', 'updateSettings', {
        webWidget: settings
      });
    },

    $_zendesk_logout() {
      window.zE('webWidget', 'logout');
    }
  }
};
